import * as p from '@clack/prompts'
import type { GeneratedSchemaField, GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { PromptFieldOptions, SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { getFieldNames } from './get-field-names.js'
import { promptConfirm } from './prompt-confirm.js'
import { promptField } from './prompt-field.js'

export async function promptChildFields(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind,
  schemasDir: string,
  scope: 'schema' | 'list-item',
  fields: GeneratedSchemaField[],
  depth: number,
  options: PromptFieldOptions = {}
): Promise<void> {
  while (true) {
    const addChild =
      fields.length === 0
        ? await promptConfirm(context, 'Add a child field?', true)
        : await promptConfirm(context, 'Add another child field?', false)

    if (!addChild) {
      if (fields.length === 0) {
        p.log.warn('Containers need at least one child field.')
        continue
      }
      return
    }

    fields.push(
      await promptField(context, kind, schemasDir, scope, depth + 1, {
        ...options,
        existingNames: getFieldNames(fields)
      })
    )
  }
}
